import { cn } from '@/lib/utils'

// The Etainabl "A" at rest — the same two-bar shape EtainablSpinner animates,
// held still at badge size (.etn-mark in globals.css). The mark is drawn 50
// units tall, so the scale is the requested pixel height over 50.
const MARK_HEIGHT = 50

export function EtainablMark({ height = 16, className }: { height?: number; className?: string }) {
  return (
    <span
      className={cn('etn-mark', className)}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      style={{ ['--etn-mark-scale' as any]: height / MARK_HEIGHT }}
      aria-hidden="true"
    >
      <span className="left" />
      <span className="right" />
    </span>
  )
}

// Marks a message as ours. The mark carries it alone — no wordmark, and no
// tinted pill: the badge only ever sits on a staff card, which is already
// green- or amber-tinted, so a tint pill behind it is invisible anyway. The
// name is spoken rather than shown, since nothing visible says "Etainabl".
export function EtainablBadge({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center', className)} data-testid="etainabl-badge">
      <EtainablMark />
      <span className="sr-only">Etainabl staff</span>
    </span>
  )
}
